import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    Input,
    Inject,
} from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import {
    MostrarExcepcion,
    MostrarSpinner,
    OcultarSpinner,
} from 'app/store/actions/utils.action';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
// import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import { DxFileUploaderComponent } from 'devextreme-angular';
// import { environment } from 'environments/environment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-nueva-carga-masiva',
    templateUrl: './nueva-carga-masiva.component.html',
    styleUrls: ['./nueva-carga-masiva.component.scss'],
})
export class NuevaCargaMasivaComponent implements OnInit {
    spinner: boolean = false;
    formNuevaCarga: any;
    formNuevaCargaCompleto: boolean = false;
    catTipoCarga: any[];
    catTipoProceso: any[];
    catTipoComprobante: any[];
    catFechaEmision: any[];
    message: string = '';
    btnUpload: boolean = false;
    operacion = {
        idOperacion: 1,
    };
    files: any = [];
    public filename!: string;
    api: any;
    dataField: any = {};
    opcionAdicional: boolean = false;
    assetURL = "/uploads/layout/";
    isFactura: boolean = false;
    layoutCliente: any = [
        'Nombre/RazonSocial',
        'RFC',
        'Email',
        'Calle',
        'NumExterior',
        'NumInterior',
        'Colonia',
        'CP',
        'Ciudad',
        'UsoFactura',
        'RegimenFiscal',
        'Agregado',
        'Errores',
    ];
    layoutProducto: any = [
        'Codigo',
        'Nombre',
        'Descripcion',
        'Unidad',
        'NombreCodeProdServ',
        'Precio',
        'UnitCode',
        'CodeProdServ',
        'ObjetoImp',
        'Agregado',
        'Errores'
    ];
    layoutFactura: any = [
        'Folio',
        'No. Factura',
        'Razon Social',
        'RFC',
        'Fiscal Regime',
        'UsoCFDI',
        'Calle',
        'Colonia',
        'No. Exterior',
        'No. Interior',
        'CP',
        'Municipio',
        'Estado',
        'Forma de Pago',
        'Condiciones de Pago',
        'Metodo de Pago',
        'Observaciones',
        'ClaveProdServ',
        'Concepto',
        'ClaveUnidad',
        'Unidad',
        'Cantidad',
        'Precio Unitario',
        'Objeto Impuesto',
        'Subtotal del Concepto',
        'IVA del Concepto',
        'Total del Concepto',
        'Pedido',
        'Mail',
        'Facturado',
        'Agregado',
        'Errores'
    ];
    layoutFacturaRetIva: any = [
        'Folio',
        'No. Factura',
        'Razon Social',
        'RFC',
        'Fiscal Regime',
        'UsoCFDI',
        'Calle',
        'Colonia',
        'No. Exterior',
        'No. Interior',
        'CP',
        'Municipio',
        'Estado',
        'Forma de Pago',
        'Condiciones de Pago',
        'Metodo de Pago',
        'Observaciones',
        'ClaveProdServ',
        'Concepto',
        'ClaveUnidad',
        'Unidad',
        'Cantidad',
        'Precio Unitario',
        'Objeto Impuesto',
        'Subtotal del Concepto',
        'IVA del Concepto',
        'IVA RET Tasa',
        'IVA RET Monto',
        'Total del Concepto',
        'Pedido',
        'Mail',
        'Facturado',
        'Errores'
    ];
    layoutFacturaConDescuento: any = [
        'Folio',
        'No. Factura',
        'Razon Social',
        'RFC',
        'Fiscal Regime',
        'UsoCFDI',
        'Calle',
        'Colonia',
        'No. Exterior',
        'No. Interior',
        'CP',
        'Municipio',
        'Estado',
        'Forma de Pago',
        'Condiciones de Pago',
        'Metodo de Pago',
        'Observaciones',
        'ClaveProdServ',
        'Concepto',
        'ClaveUnidad',
        'Unidad',
        'Cantidad',
        'Precio Unitario',
        'Objeto Impuesto',
        'Subtotal del Concepto',
        'Descuento del Concepto',
        'IVA del Concepto',
        'Total del Concepto',
        'Pedido',
        'Mail',
        'Facturado',
        'Errores'
    ];
    layoutNotaCredito: any = [
        'Folio',
        'No. Factura',
        'Razon Social',
        'RFC',
        'Fiscal Regime',
        'UsoCFDI',
        'Calle',
        'Colonia',
        'No. Exterior',
        'No. Interior',
        'CP',
        'Municipio',
        'Estado',
        'Forma de Pago',
        'Condiciones de Pago',
        'Metodo de Pago',
        'Observaciones',
        'ClaveProdServ',
        'Concepto',
        'ClaveUnidad',
        'Unidad',
        'Cantidad',
        'Precio Unitario',
        'Objeto Impuesto',
        'Subtotal del Concepto',
        'IVA del Concepto',
        'Total del Concepto',
        'Pedido',
        'TipoRelacion',
        'UUIDRelacion',
        'Mail',
        'Facturado',
        'Agregado',
        'Errores'
    ];
    layoutComplementoPago: any = [
        'Folio',
        'No. Factura',
        'Razon Social',
        'RFC',
        'Fiscal Regime',
        'UsoCFDI',
        'Calle',
        'Colonia',
        'No. Exterior',
        'No. Interior',
        'CP',
        'Municipio',
        'Estado',
        'FechadePago',
        'FormadePago',
        'Monto',
        'Moneda',
        'TipodeCambio',
        'FolioFiscal',
        'No.Parcialidad',
        'MonedaRel',
        'EquivalenceDocRel',
        'MetododePago',
        'ImporteSaldoAnterior',
        'ImportePagado',
        'SaldoInsoluto',
        'ObjetoImpuesto',
        'NombreImpuesto',
        'BaseImpuesto',
        'TasaImpuesto',
        'TotalImpuesto',
        'Mail',
        'Facturado',
        'Agregado',
        'Errores'
    ];
    contentData: any;
    fileCorrect: boolean = false;
    getStateUtil: any;
    subscribeUtils: any;
    idEmpresa: any;
    totalRegistros: any;

    constructor(
        public dialog: MatDialog,
        private fb: FormBuilder,
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService,
        public dialogRef: MatDialogRef<NuevaCargaMasivaComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}
    ngOnInit(): void {
        this.getStateUtil = this.store.select(selectUtilsState);
        this.subscribeUtils = this.getStateUtil.subscribe(
            (utils) => {
                this.idEmpresa = utils.empresaSeleccionada.id;
            }
        );
        this.formularioNuevaCarga();
        this.getCatTipoTarea();
    }

    formularioNuevaCarga() {
        this.formNuevaCarga = this.fb.group({
            tipoCarga: new FormControl('', Validators.required),
            tipoProceso: new FormControl(''),
            tipoComprobante: new FormControl(''),
            fechaEmision: new FormControl('')
        });
    }

    getCatTipoTarea() {
        this.srvcoal.getService(`cat-tarea-tipos`).subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.catTipoCarga = res.data;
                    console.log('--------catTipoCarga----------');
                    console.log(this.catTipoCarga);
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    getCatTipoProceso(): void {
        this.srvcoal.getService(`cat-tipo-procesos`).subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.catTipoProceso = res.data;
                    console.log('--------catTipoProceso----------');
                    console.log(this.catTipoProceso);
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    getCatTipoComprobante(): void {
        this.srvcoal.getService(`cat-tipo-comprobantes?populate=*&filters[masivo][$eq]=true`).subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.catTipoComprobante = res.data;
                    console.log('--------catTipoComprobante----------');
                    console.log(this.catTipoComprobante);

                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    getCatFechaEmision(): void {
        this.srvcoal.getService(`cat-fecha-emisiones`).subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.catFechaEmision = res.data;
                    console.log('--------catFechaEmision----------');
                    console.log(this.catFechaEmision);
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    cerrar(status: any = 0) {
        if (status === 1) {
            this.dialogRef.close({
                success: status,
            });
        } else {
            this.dialogRef.close({ success: status });
        }
    }

    downloadTemplate() {
        let tipoCarga: any[] = this.catTipoCarga.filter( (x) => x.id === this.formNuevaCarga.value.tipoCarga );
        let extension = ".xlsx";
        if(tipoCarga.length === 0)
            return;
        let nombreTemplate = tipoCarga[0]?.attributes?.tipo;
        if (nombreTemplate === 'Clientes' || nombreTemplate === 'Productos') {
            extension = ".csv";
        }
        if(nombreTemplate === 'Factura') {
            let tipoComprobante: any[] = this.catTipoComprobante.filter( (x) => x.id === this.formNuevaCarga.value.tipoComprobante );
            if(tipoComprobante.length === 0)
                return;
            nombreTemplate = tipoComprobante[0]?.attributes?.nombre;
        }
        FileSaver.saveAs(environment.hostBack + this.assetURL + nombreTemplate + extension, nombreTemplate + extension);
    }

    submitInputFile(e: any, fileUploader: DxFileUploaderComponent) {
        this.files = [];
        let file = fileUploader.value[0];
        var reader = new FileReader();

        reader.onload = (e: any) => {
            /* read workbook */
            let bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            /* grab first sheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* save data */
            this.contentData = XLSX.utils.sheet_to_json(ws, {
                header: 1,
                raw: false,
                dateNF: 'yyyy/mm/dd',
            });

            // Quitamos rows vacios
            const filas = this.contentData.filter(
                (row) => row.some(cell => cell !== null && cell.toString().trim() !== "")
            );

            this.totalRegistros = filas.length - 1;
            this.contentData = this.contentData.filter(
                (arr) => !this.isElementEmpty(arr)
            );
            this.filename = file.name;
            if (this.validacionCarga()) {
                this.message = 'Documento cargado ' + this.filename;
                this.files.push(file);
                this.files.push(file);
            }
        };
        reader.readAsBinaryString(file);
    }

    isElementEmpty(arr: any): boolean {
        return arr.every((value) => value === '');
    }

    onValueChanged = (e: any, fileUploader: DxFileUploaderComponent) => {

    };

    validacionCarga() {
        this.isFactura = false;
        let layoutCorrecto = [];
        switch(this.formNuevaCarga.value.tipoCarga) {
            case 1: {
                layoutCorrecto = this.layoutProducto.filter(
                    (x) => this.contentData[0].indexOf(x) === -1
                );
               break;
            }
            case 2: {
                layoutCorrecto = this.layoutCliente.filter(
                    (x) => this.contentData[0].indexOf(x) === -1
                );
               break;
            }
            case 4: {
                let tipoComprobante = this.catTipoComprobante.filter( (x) => x.id === this.formNuevaCarga.value.tipoComprobante );
                if(tipoComprobante[0]?.attributes?.nombre === "Factura") layoutCorrecto = this.layoutFactura.filter( (x) => this.contentData[0].indexOf(x) === -1 );
                if(tipoComprobante[0]?.attributes?.nombre === "Factura con Descuento") layoutCorrecto = this.layoutFacturaConDescuento.filter( (x) => this.contentData[0].indexOf(x) === -1 );
                if(tipoComprobante[0]?.attributes?.nombre === "Factura con retención de IVA") layoutCorrecto = this.layoutFacturaRetIva.filter( (x) => this.contentData[0].indexOf(x) === -1 );
                if(tipoComprobante[0]?.attributes?.nombre === "Nota de Credito") layoutCorrecto = this.layoutNotaCredito.filter( (x) => this.contentData[0].indexOf(x) === -1 );
                if(tipoComprobante[0]?.attributes?.nombre === "Complemento de Pago") layoutCorrecto = this.layoutComplementoPago.filter( (x) => this.contentData[0].indexOf(x) === -1 );
               break;
            }
            default: {
                layoutCorrecto = ["No es posible verificar el layout."]
               break;
            }
         }

        if (layoutCorrecto.length > 0) {
            this.fileCorrect = false;
            return this._snackBar.open(
                'El layout no es correcto, validar los siguientes campos: \n' +
                    layoutCorrecto.join(),
                'OK',
                { duration: 5000 }
            );
        }
        this.fileCorrect = true;
        return this.fileCorrect;
    }

    insertarTarea() {
        if(this.opcionAdicional) {
            if(this.formNuevaCarga.value.tipoComprobante === "") {
                this.formNuevaCarga.controls.tipoComprobante.setErrors("required")
                this.formNuevaCarga.controls.tipoComprobante.markAsTouched();
                return this.datosIncompletos();
            }
            if(this.formNuevaCarga.value.fechaEmision === "") {
                this.formNuevaCarga.controls.fechaEmision.setErrors("required")
                this.formNuevaCarga.controls.fechaEmision.markAsTouched();
                return this.datosIncompletos();
            }
        }
        this.formNuevaCarga.markAllAsTouched();
        this.formNuevaCarga.updateValueAndValidity();
        if (!this.formNuevaCarga.valid) {
            return this.datosIncompletos();
        }

        if (!this.fileCorrect) {
            return this._snackBar.open(
                'Favor de ingresar un archivo correcto',
                'OK',
                { duration: 3000 }
            );
        }

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea guardar este registro?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result == 1) {
                this.store.dispatch(MostrarSpinner());
                this.spinner = true;
                var datosTarea = this.formNuevaCarga.value;
                const formData = new FormData();
                for (var i = 0; i < this.files.length; i++) {
                    formData.append(`files`, this.files[i]);
                }
                this.srvcoal.postServiceFile('upload', formData).subscribe(
                    (file: any) => {
                        let tareaBody = {
                            data: {
                                fechaInicio: Date.now(),
                                fechaFin: null,
                                archivoOriginal: file[0].id,
                                cat_tarea_estatus: 1,
                                cat_tarea_tipo: datosTarea.tipoCarga,
                                parametros: null,
                                archivoProcesado: file[1].id,
                                registrosTotal: this.totalRegistros,
                                registrosProcesados: 0,
                                cat_tipo_comprobante: null,
                                cat_fecha_emision: null
                            },
                        };
                        if(this.opcionAdicional) {
                            tareaBody.data.cat_tipo_comprobante = this.formNuevaCarga.value.tipoComprobante;
                            tareaBody.data.cat_fecha_emision = this.formNuevaCarga.value.fechaEmision;
                        }
                        this.srvcoal
                            .postServiceFile('tar-tareas', tareaBody)
                            .subscribe(
                                (tarea: any) => {
                                    /** */
                                    let taskCompany = {
                                        data : {
                                            "ope_empresas": [this.idEmpresa]
                                        }
                                    }
                                    this.srvcoal
                                    .postServiceFile('ope-empresas/add-task/' + tarea.data.id, taskCompany)
                                    .subscribe(
                                        (resp: any) => {
                                            this.formNuevaCarga.reset();
                                            this.cerrar(1);
                                            this.store.dispatch(OcultarSpinner());
                                            this.spinner = false;
                                        },
                                        (error: any) => {
                                            this.store.dispatch(OcultarSpinner());
                                            this.spinner = false;
                                            console.log(error);
                                            return this._snackBar.open(
                                                error.message,
                                                'Error',
                                                { duration: 3000 });
                                        }
                                    );
                                    /** */
                                },
                                (error: any) => {
                                    this.store.dispatch(OcultarSpinner());
                                            this.spinner = false;
                                    console.log(error);
                                    return this._snackBar.open(
                                        error.message,
                                        'Error',
                                        { duration: 3000 }
                                    );
                                }
                            );
                    },
                    (error: any) => {
                        console.log(error);
                        this.store.dispatch(OcultarSpinner());
                                            this.spinner = false;
                        return this._snackBar.open(
                            error.message,
                            'Error',
                            { duration: 3000 });
                    }
                );
            }
        });
    }

    datosIncompletos() {
        return this._snackBar.open(
            'Favor de completar los datos requeridos',
            'OK',
            { duration: 3000 }
        );
    }

    changeTipoCarga(): void {
        let tipoCarga = this.catTipoCarga.filter( (x) => x.id === this.formNuevaCarga.value.tipoCarga );
        if(tipoCarga[0]?.attributes?.tipo === "Factura" || tipoCarga[0]?.attributes?.tipo === "Complemento de Pago") {
            this.getCatTipoProceso();
            this.getCatTipoComprobante();
            this.getCatFechaEmision();
            this.opcionAdicional = true;
        }
        else this.opcionAdicional = false;
    }
}
